<template>
	<div class="input-wrapper flex">
		<div class="input-with-icon">

			<input v-model="filterText" placeholder="Search help topics" />
			<transition-group name="fade">
				<div class="results-dropdown-bg" v-if="filterResults.length > 0" @click="resetFilterText" key="bg"></div>
				<div class="results-dropdown shadow" v-if="filterResults.length > 0" key="results">
					<div class="result" v-for="result in filterResults" @click="emitChosenFaq(result)" :key="result.id">
						{{ result.question }}
					</div>
				</div>
			</transition-group>
		</div>
	</div>
</template>

<script>
export default {
    name: 'FaqFilterInput',
    props: {
        faqArray: {
            required: true,
            type: Array,
        },
    },
    data () {
        return {
            filterText: '',
        };
    },
    methods: {
        resetFilterText () {
            this.filterText = '';
        },
        emitChosenFaq (chosenFaq) {
            this.$emit('chosenFaqFromFilter', chosenFaq);
            this.filterText = '';
        },
    },
    computed: {
        filterResults () {
            let faqArray = [];
            if (this.filterText !== '' && this.filterText.length > 2) {
                // search
                const tempArray = [...this.faqArray];
                faqArray = tempArray.filter((faqItem) => {
                    let match = false;
                    if (faqItem.question.toLowerCase().search(this.filterText.toLowerCase()) > -1) {
                        match = true;
                    } else if (faqItem.answer.toLowerCase().search(this.filterText.toLowerCase()) > -1) {
                        match = true;
                    }
                    return match;
                });
            }
            return faqArray;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.input-wrapper {
	position: relative;
	.results-dropdown-bg {
		position: fixed;
		background: rgba(0, 0, 0, 0.15);
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		transition: all 0.6s ease-in-out;
		z-index: -1;
	}
	.results-dropdown {
		transition: all 0.6s ease-in-out;
		position: absolute;
		width: 100%;
		left: 0;
		right: 0;
		padding: 1rem;
		background: white;
		max-height: 300px;
		overflow-y: auto;
		overflow-x: hidden;
		z-index: 1;
		.result {
			padding: 0.5rem 1rem;
			cursor: pointer;
			&:hover {
				background: #e6e6e6;
			}
		}
	}
}
.input-with-icon {
	position: relative;
	width: 30rem;
	// height: 2.5rem;

	border-radius: 0.5rem;
	z-index: 2;

	// overflow: hidden;
	input {
		width: 100%;
		height: 100%;
		padding: 1rem;
		border: 1px solid #e6e6e6;
		border-radius: inherit;
		&::placeholder {
			@include responsive("sm") {
				font-size: 0.9rem;
			}
		}
	}
}
</style>
